import declare from "dojo/_base/declare";
import SizeChart from "../SizeChart";
import { Context } from "csi/def/Context";

const ActualGapMixin = declare(null, {
	_getActual: function(ctx: Context) {
		return null; // default value to be over-ridden
	},

	_getTarget: function(ctx: Context) {
		return null; // default value to be over-ridden
	},

	_gap: function(/*Number*/n1, /*Number*/n2) {
		return null; // default value to be over-ridden
	},

	_getDiff: function(value: number, target: number) {
		// summary: return value since it is already the difference
		return value;
	},

	_getValueGap: function(ctx: Context) {
		// summary: return difference between actual and target value
		const value = this._getActual(ctx);
		return (SizeChart.isNotInitialized(value)) ? value : this._gap(value, this._getTarget(ctx));
	},
});

export = ActualGapMixin;